var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRemoveOutliers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.removeOutliers{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "removeOutliers",
    d: "M14.78,10.28L13.06,12l1.72,1.72c0.29,0.29,0.29,0.77,0,1.06C14.63,14.93,14.44,15,14.25,15 s-0.38-0.07-0.53-0.22L12,13.06l-1.72,1.72C10.13,14.93,9.94,15,9.75,15s-0.38-0.07-0.53-0.22c-0.29-0.29-0.29-0.77,0-1.06L10.94,12 l-1.72-1.72c-0.29-0.29-0.29-0.77,0-1.06c0.29-0.29,0.77-0.29,1.06,0L12,10.94l1.72-1.72c0.29-0.29,0.77-0.29,1.06,0 C15.07,9.51,15.07,9.99,14.78,10.28z M7,9.79v4.5c0,0.41-0.34,0.75-0.75,0.75h-4.5C1.34,15.04,1,14.7,1,14.29v-4.5 c0-0.41,0.34-0.75,0.75-0.75h4.5C6.66,9.04,7,9.38,7,9.79z M5.5,10.54h-3v3h3V10.54z M7,1.75v4.5C7,6.66,6.66,7,6.25,7h-4.5 C1.34,7,1,6.66,1,6.25v-4.5C1,1.34,1.34,1,1.75,1h4.5C6.66,1,7,1.34,7,1.75z M5.5,2.5h-3v3h3V2.5z M15,1.75v4.5 C15,6.66,14.67,7,14.25,7h-4.5C9.34,7,9,6.66,9,6.25v-4.5C9,1.34,9.34,1,9.75,1h4.5C14.67,1,15,1.34,15,1.75z M13.5,2.5h-3v3h3V2.5z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemoveOutliers);
export default __webpack_public_path__ + "static/media/icon_remove-outliers.ad66c565a06929d87ade89217a4710e4.svg";
export { ForwardRef as ReactComponent };